import { useTraccarMessage } from './useTraccarSocket';
import { useCommandsStore } from '@/stores/commands';

/**
 * Escuta o WebSocket pra confirmar comandos pendentes por dois caminhos:
 *
 * 1. Evento `commandResult` (caminho oficial do Traccar, quando o protocolo
 *    do equipamento gera resposta).
 * 2. Mudança de estado na posição: quando uma posição posterior ao envio
 *    do comando confirma o efeito esperado (RELAY,1# → blocked=true etc).
 *    Isso cobre equipamentos que executam o comando mas não geram evento.
 */
function readBlockedAttr(
  attrs: Record<string, unknown> | null | undefined,
): boolean | undefined {
  if (!attrs) return undefined;
  const v = attrs.blocked;
  if (typeof v === 'boolean') return v;
  if (typeof v === 'string') return v.toLowerCase() === 'true' || v === '1';
  if (typeof v === 'number') return v !== 0;
  return undefined;
}

export function useCommandResultListener() {
  const confirm = useCommandsStore((s) => s.confirm);
  const inferConfirmFromPosition = useCommandsStore((s) => s.inferConfirmFromPosition);

  useTraccarMessage((msg) => {
    if (msg.events?.length) {
      for (const event of msg.events) {
        if (event.type !== 'commandResult') continue;
        if (event.deviceId == null) continue;
        const result =
          typeof event.attributes?.result === 'string'
            ? (event.attributes.result as string)
            : undefined;
        confirm(event.deviceId, event.id, result);
      }
    }
    if (msg.positions?.length) {
      for (const p of msg.positions) {
        if (p.deviceId == null || !p.fixTime) continue;
        inferConfirmFromPosition(p.deviceId, {
          blocked: readBlockedAttr(p.attributes),
          fixTime: p.fixTime,
        });
      }
    }
  });
}
